"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageSize = void 0;
const get_manifest_1 = require("./get-manifest");
const options_1 = require("./options");
/**
 * Calculates the total size of an image in bytes.
 *
 * Computes the sum of all layer sizes for a container image by retrieving the manifest
 * and summing the size of each layer. Useful for determining image download size and storage requirements.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/manifests/<reference>`
 *
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param tag - The image tag or digest (e.g., "1.19", "sha256:abc123...")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns Total image size in bytes
 *
 * @throws {Error} When manifest cannot be found or layers are unavailable
 */
async function getImageSize(registryBase, repo, tag, username, password, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const manifest = await (0, get_manifest_1.getManifest)(registryBase, repo, tag, username, password, cloned, undefined, observer);
    const layers = manifest.layers || [];
    return layers.reduce((size, layerConfig) => size + layerConfig.size, 0);
}
exports.getImageSize = getImageSize;
//# sourceMappingURL=get-image-size.js.map